/**
 * The fixed lists of the wish box (spec 2026-11-01-analytics-gaps-and-wish-box-design.md, section 1).
 *
 * `POST /common/feedback` (server and music24-api), both event catalogs and the admin Wishes pages
 * read them. The native apps keep a copy of the values in their catalog files. No react-intl here:
 * each app holds its own labels.
 */

/** What a feedback row is. A row with no `kind` is `feedback`. */
export const FEEDBACK_KINDS = ['feedback', 'wish', 'rateFeedback'] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

export const FYM_WISH_TOPICS = ['service', 'transfers', 'playlistTools', 'stats', 'sharing', 'other'] as const;
export type FymWishTopic = (typeof FYM_WISH_TOPICS)[number];

export const MUSIC24_WISH_TOPICS = ['studio', 'promote', 'smartlinks', 'outreach', 'analytics', 'other'] as const;
export type Music24WishTopic = (typeof MUSIC24_WISH_TOPICS)[number];

/** The chips of the "Not really" page of the rate sheet. */
export const RATE_FEEDBACK_TOPICS = ['matching', 'missing', 'speed', 'app', 'other'] as const;
export type RateFeedbackTopic = (typeof RATE_FEEDBACK_TOPICS)[number];

/** Where the person opened the wish box. It is `from` of `wish_box_opened`, `surface` of a row. */
export const WISH_SURFACES = ['account', 'settings', 'noResult', 'rateSheet'] as const;
export type WishSurface = (typeof WISH_SURFACES)[number];

/** The longest note of a wish. */
export const WISH_NOTE_MAX_LENGTH = 500;
